import { Link } from 'react-router-dom';

const steps = [
  'выявление перспективных сотрудников',
  'определение готовности к новой роли',
  'выявление дефицита управленческих компетенций',
  'индивидуальный план развития',
  'обучение',
  'наставничество',
  'практика',
  'повторная оценка',
];

export default function TalentPool() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Кадровый резерв
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Оценка помогает не просто составить список перспективных сотрудников, а подготовить будущих руководителей.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {steps.map((s, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100 hover:border-teal-200 transition-colors">
              <div className="w-8 h-8 bg-teal-600 text-white rounded-lg flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-sm font-bold">{i + 1}</span>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{s}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-sm md:text-base text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Развитие управленческих компетенций и подготовка руководителей подробно раскрыты в кластере{' '}
          <Link to="/menedzhment-i-liderstvo" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
            «Менеджмент и лидерство»
          </Link>{' '}
          и на странице{' '}
          <Link to="/enciklopediya-korporativnogo-obucheniya/trening-dlya-rukovoditeley" className="text-teal-600 hover:text-teal-700 font-semibold cursor-pointer">
            «Тренинг для руководителей»
          </Link>.
        </p>
      </div>
    </section>
  );
}